import * as _ from 'lodash';
import * as moment from 'moment';
import { ClonableItem } from 'src/app/shared';
import { IProcessCalculationStatistic } from '../interfaces/process-calculation-statistic.interface';
import IProcessCalculationStatisticDTO = ZoningAPI.IProcessCalculationStatisticDTO;

export class ProcessCalculationStatistic extends ClonableItem<IProcessCalculationStatistic>
    implements IProcessCalculationStatistic {
    CalcTimeMs: number;
    SaveToDBTimeMs: number;
    SrvCalcTimeMs: number;
    DataLoadTimeMs: number;
    CRsInPeriod?: number;
    CRsPerHour?: number;
    createdAt?: string;
    GISCalcTimeMs?: number;
    TotalTimeMs?: number;
    TransferTimeMs?: number;
    createdAtM?: moment.Moment;

    ThreadsCount?: number;
    BunchSize?: number;

    CRsStatuses?: number[];
    TotalCRs?: number;
    AVGCRsPerHour?: number;
    TotalCRsStatuses?: number[];
    AVGCalcTimeMs?: number;
    AVGSaveToDBTimeMs?: number;
    AVGSrvCalcTimeMs?: number;
    AVGDataLoadTimeMs?: number;

    AVGGISCalcTimeMs?: number;
    AVGTotalTimeMs?: number;
    AVGTransferTimeMs?: number;

    TotalPRsInProgress?: number;
    CRsPerHourPerThread?: number;

    GAPIDataLoadDuration?: number;
    WaitForDataDuration?: number;
    DataSetsCached?: number;
    CachingIterationsCount?: number;

    DesiredPRsCount?: number;
    DesiredAbuttingPRsCount?: number;
    DesiredStreetsCount?: number;
    DesiredPRTagsCount?: number;

    CachedPropertyRecordsCount?: number;
    CachedAbuttingPRsCount?: number;
    CachedStreetsCount?: number;
    CachedPRTagsCount?: number;

    RequestedPropertyRecordsCount?: number;
    RequestedAbuttingPRsCount?: number;
    RequestedStreetsCount?: number;
    RequestedPRTagsCount?: number;

    CacheSize?: number;
    CalculatedCacheSizeBytes?: number;

    ReceivedPropertyRecordsCount?: number;
    ReceivedAbuttingPRsCount?: number;
    ReceivedStreetsCount?: number;
    ReceivedPRTagsCount?: number;

    MissedPropertyRecordsCount?: number;
    MissedAbuttingPRsCount?: number;
    MissedStreetsCount?: number;
    MissedPRTagsCount?: number;

    constructor(data: IProcessCalculationStatistic) {
        super(data);
        this.createdAtM = moment(this.createdAt);
    }

    getJSON() {
        return _.pick(this, [
            'CalcTimeMs',
            'SaveToDBTimeMs',
            'SrvCalcTimeMs',
            'DataLoadTimeMs',
            'CRsInPeriod',
            'CRsPerHour',
            'createdAt',
            'GISCalcTimeMs',
            'TotalTimeMs',
            'TransferTimeMs',
            'ThreadsCount',
            'BunchSize',

            'CRsStatuses',
            'TotalCRs',
            'AVGCRsPerHour',
            'TotalCRsStatuses',
            'AVGCalcTimeMs',
            'AVGSaveToDBTimeMs',
            'AVGSrvCalcTimeMs',
            'AVGDataLoadTimeMs',

            'AVGGISCalcTimeMs',
            'AVGTotalTimeMs',
            'AVGTransferTimeMs',

            'TotalPRsInProgress',
            'CRsPerHourPerThread',

            'GAPIDataLoadDuration',
            'WaitForDataDuration',
            'DataSetsCached',
            'CachingIterationsCount',

            'DesiredPRsCount',
            'DesiredAbuttingPRsCount',
            'DesiredStreetsCount',
            'DesiredPRTagsCount',

            'CachedPropertyRecordsCount',
            'CachedAbuttingPRsCount',
            'CachedStreetsCount',
            'CachedPRTagsCount',

            'RequestedPropertyRecordsCount',
            'RequestedAbuttingPRsCount',
            'RequestedStreetsCount',
            'RequestedPRTagsCount',

            'CacheSize',
            'CalculatedCacheSizeBytes',

            'ReceivedPropertyRecordsCount',
            'ReceivedAbuttingPRsCount',
            'ReceivedStreetsCount',
            'ReceivedPRTagsCount',

            'MissedPropertyRecordsCount',
            'MissedAbuttingPRsCount',
            'MissedStreetsCount',
            'MissedPRTagsCount'
        ]);
    }

    setCreatedAt(value: moment.Moment) {
        this.createdAtM = value;
        this.createdAt = this.createdAtM.toISOString();
    }

    isEqualNumericValues(item: ProcessCalculationStatistic) {
        return item ? _.isEqual(_.omit(this.getJSON(), ['createdAt']), _.omit(item.getJSON(), ['createdAt'])) : false;
    }
}

export function ProcessCalculationStatisticFactory(data: IProcessCalculationStatisticDTO) {
    return new ProcessCalculationStatistic(data);
}

export function getIntermediateStatisticIteration(
    data?: IProcessCalculationStatisticDTO,
    fieldsToInherit?: string[]
): IProcessCalculationStatisticDTO {
    const result: IProcessCalculationStatisticDTO = {
        ThreadsCount: 0,
        BunchSize: 0,

        CalcTimeMs: 0,
        SaveToDBTimeMs: 0,
        SrvCalcTimeMs: 0,
        DataLoadTimeMs: 0,
        CRsInPeriod: 0,
        CRsPerHour: 0,
        GISCalcTimeMs: 0,
        TotalTimeMs: 0,
        TransferTimeMs: 0,

        CRsStatuses: [],
        TotalCRs: 0,
        AVGCRsPerHour: 0,
        TotalCRsStatuses: [],
        AVGCalcTimeMs: 0,
        AVGSaveToDBTimeMs: 0,
        AVGSrvCalcTimeMs: 0,
        AVGDataLoadTimeMs: 0,
        AVGTransferTimeMs: 0,

        AVGGISCalcTimeMs: 0,
        AVGTotalTimeMs: 0,

        TotalPRsInProgress: 0,
        CRsPerHourPerThread: 0,

        GAPIDataLoadDuration: 0,
        WaitForDataDuration: 0,
        DataSetsCached: 0,
        CachingIterationsCount: 0,

        DesiredPRsCount: 0,
        DesiredAbuttingPRsCount: 0,
        DesiredStreetsCount: 0,
        DesiredPRTagsCount: 0,

        CachedPropertyRecordsCount: 0,
        CachedAbuttingPRsCount: 0,
        CachedStreetsCount: 0,
        CachedPRTagsCount: 0,

        RequestedPropertyRecordsCount: 0,
        RequestedAbuttingPRsCount: 0,
        RequestedStreetsCount: 0,
        RequestedPRTagsCount: 0,

        CacheSize: 0,
        CalculatedCacheSizeBytes: 0,

        ReceivedPropertyRecordsCount: 0,
        ReceivedAbuttingPRsCount: 0,
        ReceivedStreetsCount: 0,
        ReceivedPRTagsCount: 0,

        MissedPropertyRecordsCount: 0,
        MissedAbuttingPRsCount: 0,
        MissedStreetsCount: 0,
        MissedPRTagsCount: 0
    };

    if (data && !_.isEmpty(fieldsToInherit)) {
        fieldsToInherit.forEach(field => {
            result[field] = data[field];
        });
    }

    return result;
}
